import React from "react";
import moment from "moment";
import "./IncidentSidebar.scss";

const IncidentDueDate = ({ dueDate, status, resolution }) => (
  <div className="flex-container">
    <div>
      <span className="inc-title">Due Date: </span>
      {dueDate ? moment(dueDate).format("YYYY-MM-DD HH:mm") : '-'}
    </div>
    <div>
      <span className="inc-title">Status: </span>
      {status ? status.name : '-'}
    </div>
    <div>
      <span className="inc-title">Resolution: </span>
      {resolution ? resolution.name : '-'}
    </div>
  </div>
);

export default IncidentDueDate;
